export const VERIFY_STORE_VOUCHER_ERROR =
  'VERIFY_STORE_VOUCHER_ERROR';
export const VERIFY_STORE_VOUCHER_START =
  'VERIFY_STORE_VOUCHER_START';
export const VERIFY_STORE_VOUCHER_SUCCESS =
  'VERIFY_STORE_VOUCHER_SUCCESS';

export const CLEAR_CANCEL_TRANSACTION = 'CLEAR_CANCEL_TRANSACTION';
